import Component from "./../../component";

export const CartDrawerConfig = {
    signature: 'cartDrawer',
    baseHtmlClass: 'go-cart__drawer',
    selector: '.go-cart__drawer',
    initedHtmlClassModifier: 'inited',
    emptyHtmlClassModifier: 'empty'
};

export class CartDrawer extends Component {

    constructor(id_or_element, goCart) {
        super({
            element: id_or_element,
            config: CartDrawerConfig
        });

        this.goCart = goCart;

        this.isEmpty = null;

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, CartDrawerConfig.initedHtmlClassModifier);
        if (this.isEmpty !== null) {
            this.conditionallySetHtmlClassState(this.isEmpty, CartDrawerConfig.emptyHtmlClassModifier);
        }
    }

}
